import gql from 'graphql-tag'

// eslint-disable-next-line import/prefer-default-export
export const UPDATE_LAST_LOGIN = gql`
  mutation updateLastLogin {
    updateStudentAppLastLogin {
      id
      success
      message
    }
  }
`

export const BATCH_CREATE_ADMIN_USERS = gql`
  mutation batchCreateAdminUsers($input: BatchCreateAdminUsersInput!) {
    batchCreateAdminUsers(input: $input) {
      createdUsers {
        id
        email
        firstName
        lastName
      }
      failedUsers {
        email
        firstName
        lastName
      }
      updatedUsers {
        id
        email
        firstName
        lastName
      }
    }
  }
`

export const COMPLETED_COURSE_PREFERENCE = gql`
  mutation upsertCompletedCoursePreference($input: CompletedCoursePreferenceInput!) {
    upsertCompletedCoursePreference(input: $input) {
      id
      success
      message
    }
  }
`
